(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ProgettoDetailController', ProgettoDetailController);

    ProgettoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Progetto', 'Finanziamento', 'Utente'];

    function ProgettoDetailController($scope, $rootScope, $stateParams, previousState, entity, Progetto, Finanziamento, Utente) {
        var vm = this;

        vm.progetto = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:progettoUpdate', function(event, result) {
            vm.progetto = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
